import { createFileRoute, redirect } from "@tanstack/react-router";

import { buildLocalizedPagePath } from "@/lib/localized-page-path";

export const Route = createFileRoute("/_about/about/providers")({
  beforeLoad: ({ context: { locale } }) => {
    throw redirect({
      href: buildLocalizedPagePath(locale, "about", "providers"),
      statusCode: 301,
    });
  },
});
